<div class="chart-container">
  <h3 class="title text-hard-blue">Chamados por mês</h3>
  <canvas
    *ngIf="chartInfo"
    baseChart
    height="100"
    chartType="bar"
    [datasets]="chartData"
    [labels]="chartLabels"
    [colors]="chartColors"
    [options]="chartOptions"
    [legend]="false"
  >
  </canvas>
</div>
